import React, {Component} from 'react';
// import moment from 'moment';
import DatePicker from 'react-datepicker';
import {connect} from 'react-redux';
import {FadeLoader} from 'react-spinners';
import moment from 'moment';
import 'rc-tooltip/assets/bootstrap_white.css';
import TablaInmatriculacionCorreo from './tablasInmatriculacion/tblInmatriculacionCorreo';
import {
    loadInmatriculacionCorreo,
    fetchInmatriculacionCorreo,
    fetchInmatriculacionCorreoDescarga,
    postInmatriculacionCorreo,
    fetchEstadoPedido,
    PAG_0, PAG_1, CANT_X_PAG
} from '../actions';
import {fetchSituacion} from '../actions/MaestroGenerico';
import MainRowSection from '../components/Inmatriculacion/MainRowSection';
import getTablaTipos from '../utils/getTablaTipos';
import showModal from "../pages/Inmatriculacion/showModal";
import ComboCheck from '../components/TableActions/comboCheck.js';
import saveAs from '../utils/downloadFile';

const COMBO_CHECK_OFICINA_REGISTRAL = 'COMBO_CHECK_OFICINA_REGISTRAL';
const COMBO_CHECK_SITUACIONES = 'COMBO_CHECK_SITUACIONES';
const COMBO_CHECK_TIPO_CONSULTA = 'COMBO_CHECK_TIPO_CONSULTA';
const COMBO_CHECK_ESTADOPED = 'COMBO_CHECK_ESTADOPED';
const CO_GRUPO_OFICINA_REGISTRAL = 58;
const CO_GRUPO_FILTRO_FECHA = 60;
const CO_GRUPO_FILTRO_CONSULTA = 62;

const ANIO = moment().year();
const MES = moment().month() + 1;
const DIA = moment().date();


const DATE_INICIO_LOAD = moment(moment(`${DIA}/${MES}/${ANIO}`, 'DD/MM/YYYY').subtract(1, 'month'));
const DATE_FIN_LOAD = moment(moment(`${DIA}/${MES}/${ANIO}`, 'DD/MM/YYYY').add(1, 'month'));


var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};

const domain = {
    titulo: '',
    tipoConsulta: '1',
    tipoFiltro: 'P',
    filtro: '',
    tipoFecha: '1',
    estadoPedido: '',
    fechaInicio: DATE_INICIO_LOAD,
    fechaFin: DATE_FIN_LOAD,
    chasis: '',
    cliente: '',
    oficinaRegistralId: '',
    indicadorEnviado: '',
    searchOption: 'npedido',
    searchOptionValue: '',
    checkSituaciones: [],
    checkOficinaRegistral: [],
    checkTipoConsulta: [],
    checkEstadoPed: [],
    registros: [],
    selectedID: [],
    selectOficinaRegistral: '',
    muestraModalMasFiltros: 'none',
    selectRow: {}
};
const defaultProperties = {
    comboSelected: '',
    dataRows: [],
    closeModal: false,
    cantidadPaginas: 0,
    totalRegistros: 0,
    nroPag: 0,
    nInicio: 0,
    nFin: 0,
    muestraLoad: 'none',
    mensajeAlert: '',
    colorBackground: '#fcbc61',
    iconAlert: 'ion-alert-circled',
    modalOpen: '',
    cmbFiltroFecha: [],
    cmbFiltroEstadoPedido: [],
    cmbTipoConsulta: [],
    oficinaRegistral: [],
    situaciones: [],
};
const cleanFiltro = {
    comboSelected: '',
    dataRows: [],
    selectedID: [],
    closeModal: false,
    muestraLoad: 'none',
    mensajeAlert: '',
    colorBackground: '#fcbc61',
    iconAlert: 'ion-alert-circled',
    modalOpen: '',
};

const cleanPaginacion = {
    cantidadPaginas: 0,
    totalRegistros: 0,
    nroPag: 0,
    nInicio: 0,
    nFin: 0,
};

class InmatriculacionCorreo extends Component {
    static handleClick(e) {
        e.currentTarget.parentNode.classList.toggle('open');
    }

    static hideMessage() {
        document.getElementById('alert').style.display = 'flex';
        setTimeout(() => {
            if (document.getElementById('alert')) {
                document.getElementById('alert').style.display = 'none';
            }
        }, 5000);
    }


    constructor(props) {
        super(props);
        this.state = _extends({}, domain, defaultProperties);

        this.handleOnClickAll = this.handleOnClickAll.bind(this);
        this.onClickOptinTab = this.onClickOptinTab.bind(this);
        this.handleChangeFechaInicio = this.handleChangeFechaInicio.bind(this);
        this.handleChangeFechaFin = this.handleChangeFechaFin.bind(this);

        this.changeCliente = this.changeCliente.bind(this);
        this.enviarCorreo = this.enviarCorreo.bind(this);
        this.initPaginacion = this.initPaginacion.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
        this.clickDescargarExcel = this.clickDescargarExcel.bind(this);
        this.handleClickComboCheck = this.handleClickComboCheck.bind(this);
        this.handleInputChangeComboCheck = this.handleInputChangeComboCheck.bind(this);
        this.abrirModalMasFiltros = this.abrirModalMasFiltros.bind(this);
        this.cerrarModalMasFiltros = this.cerrarModalMasFiltros.bind(this);
        this.cancelarModalMasFiltros = this.cancelarModalMasFiltros.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.showError = this.showError.bind(this);

        this.changeEstadoEnvio = this.changeEstadoEnvio.bind(this);
        this.changeSearchOption = this.changeSearchOption.bind(this);
        this.changeSearchOptionValue = this.changeSearchOptionValue.bind(this);
        this.changeSearchOptionFechas = this.changeSearchOptionFechas.bind(this);
        this.changeTipoConsulta = this.changeTipoConsulta.bind(this);
        this.searchAll = this.searchAll.bind(this);
        this.handleClickComboCheckFiltrar = this.handleClickComboCheckFiltrar.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.siguiente = this.siguiente.bind(this);
        this.atras = this.atras.bind(this);
        this.siguiente = this.siguiente.bind(this);
        this.atras = this.atras.bind(this);

    }

    componentDidMount() {

        document.addEventListener('click', this.handleClickComboCheck, true);
        document.addEventListener('keydown', this.onKeyDown, true);

        this.props.loadInmatriculacionCorreo();
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });
        var params = this.buildParam();
        this.props.fetchInmatriculacionCorreo(params, PAG_1, CANT_X_PAG)
            .then((result) => {
                if (result.payload.data.estadoTrama === '1') {
                    this.setState({registros: result.payload.data.resultList});
                    this.initPaginacion(result.payload.data.totalRegistros,
                        result.payload.data.cantidadPaginas);
                } else if (result.payload.data.estadoTrama === '0') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: result.payload.data.mensaje
                    });
                    InmatriculacionCorreo.hideMessage();
                } else if (result.payload.data.estadoTrama === '-1') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                    });
                    InmatriculacionCorreo.hideMessage();
                } else {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                    });
                    InmatriculacionCorreo.hideMessage();
                }
            })
            .catch((error) => {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCorreo.hideMessage();
            });

        this.props.fetchSituacion('').then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                let values = result.payload.data.itemList.map(row => ({
                    id: row.id,
                    descripcion: row.id + "-" + row.nombre
                }));
                this.setState({situaciones: values});
            }
        });

        getTablaTipos(CO_GRUPO_OFICINA_REGISTRAL).then((result) => {
            if (result.data.estadoTrama === '1') {
                let values = result.data.tablaMaestroLogistica.map(row => ({
                    id: row.codTipo,
                    descripcion: row.descripcion
                }));
                this.setState({oficinaRegistral: values});
            }
        });

        getTablaTipos(CO_GRUPO_FILTRO_FECHA).then((result) => {
            // cmbFiltroFecha
            if (result.data.estadoTrama === '1') {
                let values = result.data.tablaMaestroLogistica.map(row => ({
                    id: row.codTipo,
                    descripcion: row.descripcion
                }));
                this.setState({cmbFiltroFecha: values});
            }

        });

        getTablaTipos(CO_GRUPO_FILTRO_CONSULTA).then((result) => {
            if (result.data.estadoTrama === '1') {
                let values = result.data.tablaMaestroLogistica.map(row => ({
                    id: row.codTipo,
                    descripcion: row.descripcion
                }));
                this.setState({cmbTipoConsulta: values});
            }

        });
        this.props.fetchEstadoPedido({todos:'S'});
        document.title = 'Divemotor - Inmatriculación - Envío Correo';

        this.handleAllOption();

    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickComboCheck, true);
        document.removeEventListener('keydown', this.onKeyDown, true);
    }


    handleChange(value) {
        this.setState({indicadorEnviado: value});
    }

    onKeyDown(e) {
        const nameComponente = e.target.getAttribute('name');
        const classComponente = e.target.getAttribute('class');
        if (e.keyCode === 27) {
            document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
            this.cerrarModalMasFiltros();
        }
        if (e.keyCode === 13) {
            if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
                || (classComponente !== null && (classComponente.indexOf('checkDeGrillaEnterCerrar') >= 0))) {
                this.setState({selectedID: [], closeModal: false});
                if (document.getElementById('checkBoxAll') !== null) {
                    document.getElementById('checkBoxAll').checked = false;
                }
            }
        }
    }

    changeSearchOptionValue(e) {
        this.setState({filtro: e.target.value});
    }

    changeCliente(e) {
        this.setState({cliente: e.target.value});
    }

    changeSearchOption(e) {
        this.setState({tipoFiltro: e.target.value, filtro: ''});
    }

    changeEstadoEnvio(e) {
        this.setState({indicadorEnviado: e.target.value});
    }

    changeSearchOptionFechas(e) {
        this.setState({tipoFecha: e.target.value});
    }

    changeTipoConsulta(e) {
        this.setState({tipoConsulta: e.target.value});
    }

    /** ********************* */
    setNroPag(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPag: PAG_0});
        } else if (this.state.nroPag === 0) { // iniciacion
            this.setState({nroPag: PAG_1});
        }
    }

    setNInicio(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicio: PAG_0});
        } else if (this.state.nInicio === 0) { // iniciacion
            this.setState({nInicio: PAG_1});
        }
    }

    setNFin(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFin: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG) {
            this.setState({nFin: CANT_X_PAG});
        } else if (nuevoTotalRegistros < CANT_X_PAG) {
            this.setState({nFin: nuevoTotalRegistros});
        } else if (this.state.nFin === 0) { // iniciacion
            this.setState({nFin: CANT_X_PAG});
        } else if (this.state.nInicio === 1) {
            this.setState({nFin: CANT_X_PAG});
        }
    }

    validacionGrillaIntern(inicio, fin) {
        if (!moment(inicio, 'DD/MM/YYYY', true).isValid()) {
            throw '¡La fecha inicio es invalida, ingrese una valida, ejemplo:25/12/2017!';
        } else if (!moment(fin, 'DD/MM/YYYY', true).isValid()) {
            throw  '¡La fecha fin es invalida, ingrese una valida, ejemplo:25/12/2017!';
        } else if (!(moment(inicio, 'DD/MM/YYYY').toDate() <= moment(fin, 'DD/MM/YYYY').toDate())) {
            throw '¡La fecha inicio tiene que ser menor a la fecha fin!';
        }

    }

    validacionGrilla() {
        let fechaInicio = document.getElementById('fechaInicio').value;
        let fechaFin = document.getElementById('fechaFin').value;
        this.validacionGrillaIntern(fechaInicio, fechaFin);


        if (fechaInicio.length === 10 && fechaFin.length === 10) {
            fechaInicio = moment(fechaInicio, 'DD/MM/YYYY').format("YYYY-MM-DD");
            fechaFin = moment(fechaFin, 'DD/MM/YYYY').format("YYYY-MM-DD");
        }


        return {fechaInicio, fechaFin};
    }


    buildParam() {
        var validacion={};
        try {
            validacion = this.validacionGrilla();
        } catch (err) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: err
            });
            InmatriculacionCorreo.hideMessage();
            return;
        }
        var oficinaRegistralValue = '';
        var situacionesValue = '';
        if (this.state.checkOficinaRegistral.length > 0) {
            oficinaRegistralValue = `[${this.state.checkOficinaRegistral}]`;
        }
        if (this.state.checkSituaciones.length > 0) {
            situacionesValue = `[${this.state.checkSituaciones}]`;
        }
        var tipoConsultaValue = '';
        if (this.state.checkTipoConsulta.length > 0) {
            tipoConsultaValue = `${this.state.checkTipoConsulta}`;
        }
        var estadoPedidoValue = '';
        if (this.state.checkEstadoPed.length > 0) {
            estadoPedidoValue = `${this.state.checkEstadoPed}`;
        }
        return {
            tipoConsulta: tipoConsultaValue,
            tipoFiltro: this.state.tipoFiltro,
            filtro: this.state.filtro,
            tipoFecha: this.state.tipoFecha,
            fechaInicio: validacion.fechaInicio,
            fechaFin: validacion.fechaFin,
            cliente: this.state.cliente,
            chasis: this.state.chasis,
            titulo: this.state.titulo,
            codSituInmatri: situacionesValue,
            oficinaRegistralId: oficinaRegistralValue,
            codEstadoPedido: estadoPedidoValue,
            indicadorEnviado: this.state.indicadorEnviado
        };
    }

    search(paginaActual, cantidadPorPagina) {

        this.cerrarModalMasFiltros();
        this.setState(cleanFiltro);
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });
        this.props.loadInmatriculacionCorreo();
        var param = this.buildParam();

        this.props.fetchInmatriculacionCorreo(param, paginaActual, cantidadPorPagina)
            .then((result) => {
                if (result.payload.data.estadoTrama === '1') {
                    this.setState({registros: result.payload.data.resultList});
                    this.initPaginacion(result.payload.data.totalRegistros,
                        result.payload.data.cantidadPaginas);
                } else if (result.payload.data.estadoTrama === '0') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: result.payload.data.mensaje
                    });
                    InmatriculacionCorreo.hideMessage();
                } else if (result.payload.data.estadoTrama === '-1') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                    });
                    InmatriculacionCorreo.hideMessage();
                } else {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                    });
                    InmatriculacionCorreo.hideMessage();
                }
            })
            .catch(() => {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCorreo.hideMessage();
            });
    }


    handleChangeFechaFin(date) {
        this.setState({fechaFin: date});
    }

    handleChangeFechaInicio(date) {
        this.setState({fechaInicio: date});
    }


    searchAll() {
        try {
            this.setState({muestraLoad: 'block'});
            this.setState(cleanPaginacion);
            this.search(
                PAG_1,
                CANT_X_PAG
            );
        } catch (err) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: err
            });
            InmatriculacionCorreo.hideMessage();
        }


    }

    handleClickComboCheckFiltrar() {
        this.setState({comboSelected: ''});
        this.searchAll();
        document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
    }


    siguiente() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginas > this.state.nroPag) {
            nroPag = this.state.nroPag + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                InmatriculacionCorreo.hideMessage();
            } else {
                this.setState({nroPag});
                if ((this.state.nFin + CANT_X_PAG) < this.state.totalRegistros) {
                    this.setState({nFin: this.state.nFin + CANT_X_PAG});
                } else {
                    this.setState({nFin: this.state.totalRegistros});
                }
                if (this.state.nInicio < this.state.totalRegistros) {
                    this.setState({nInicio: this.state.nInicio + CANT_X_PAG});
                }

                this.search(nroPag, CANT_X_PAG);
            }
        }
    }

    atras() {
        let okAtras = false;
        let nroPag;
        if (this.state.nroPag > 1) {
            nroPag = this.state.nroPag - 1;
            okAtras = true;
        }
        if (okAtras) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                InmatriculacionCorreo.hideMessage();
            } else {
                this.setState({nroPag});
                if (this.state.nFin === this.state.totalRegistros) {
                    this.setState({nFin: this.state.nInicio - 1});
                } else if ((this.state.nFin - CANT_X_PAG) < this.state.totalRegistros &&
                    (this.state.nFin - CANT_X_PAG) !== this.state.totalRegistros) {
                    this.setState({nFin: this.state.nFin - CANT_X_PAG});
                }
                if (this.state.nInicio <= this.state.totalRegistros) {
                    this.setState({nInicio: this.state.nInicio - CANT_X_PAG});
                }
                this.search(nroPag, CANT_X_PAG);
            }
        }
    }


    initPaginacion(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalRegistros: parseInt(totalRegistros, 10),
            cantidadPaginas: parseInt(cantidadPaginas, 10),
        });
        this.setNroPag(totalRegistros);
        this.setNInicio(totalRegistros);
        this.setNFin(totalRegistros);
    }

    abrirModalMasFiltros() {
        this.setState({muestraModalMasFiltros: 'block'});
        document.body.style.overflow = 'hidden';
    }

    cerrarModalMasFiltros() {
        this.setState({muestraModalMasFiltros: 'none'});
        document.body.style.overflow = 'auto';
    }

    cancelarModalMasFiltros() {
        this.cerrarModalMasFiltros();
    }

    handleClickComboCheck(e) {
        const nameComponente = e.target.getAttribute('name');
        const idComponente = e.target.getAttribute('id');
        const classComponente = e.target.getAttribute('class');


        if (nameComponente === 'btnDropdownToggle') {
            if (e.target.parentNode.classList.contains('open')) {
                e.target.parentNode.classList.remove('open');
            } else {
                document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
                e.target.parentNode.classList.add('open');
            }
        } else if (nameComponente === 'iconDropdownToggle') {
            if (e.target.parentNode.parentNode.classList.contains('open')) {
                e.target.parentNode.parentNode.classList.remove('open');
            } else {
                document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
                e.target.parentNode.parentNode.classList.add('open');
            }
        } else {
            document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
        }

        if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
            || (classComponente !== null && (classComponente.indexOf('checkDeGrillaCerrar') >= 0))) {
            this.setState({selectedID: [], closeModal: false,});
            if (document.getElementById('checkBoxAll') !== null) {
                document.getElementById('checkBoxAll').checked = false;
            }
        }

        const combo = document.getElementById(this.state.comboSelected);
        if (this.state.comboSelected) {
            if (combo.contains(e.target) && combo !== e.target) {
                return;
            }
        }
        document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
        if (idComponente === this.state.comboSelected || idComponente === null) {
            this.setState({comboSelected: ''});
        } else if (nameComponente === 'divComboCheck') {
            this.setState({
                comboSelected: idComponente,
            }, e.target.classList.add('open'));
            if (idComponente === COMBO_CHECK_OFICINA_REGISTRAL) {
                getTablaTipos(CO_GRUPO_OFICINA_REGISTRAL).then((result) => {

                });
            }
            if (idComponente === COMBO_CHECK_SITUACIONES) {

            }
        }
    }

    handleInputChangeComboCheck(event, id, idComponente) {
        if (idComponente === COMBO_CHECK_SITUACIONES) {
            if (event.target.checked === true) {
                this.setState({checkSituaciones: [...this.state.checkSituaciones, id]});
            } else {
                this.setState({
                    checkSituaciones: this.state.checkSituaciones.filter(x => x !== id),
                });
            }
        }
        if (idComponente === COMBO_CHECK_OFICINA_REGISTRAL) {
            if (event.target.checked === true) {
                this.setState({checkOficinaRegistral: [...this.state.checkOficinaRegistral, id]});
            } else {
                this.setState({
                    checkOficinaRegistral: this.state.checkOficinaRegistral.filter(x => x !== id),
                });
            }
        }
        if (idComponente === COMBO_CHECK_TIPO_CONSULTA) {
            if (event.target.checked === true) {
                this.setState({checkTipoConsulta: [...this.state.checkTipoConsulta, id]});
            } else {
                this.setState({
                    checkTipoConsulta: this.state.checkTipoConsulta.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_ESTADOPED) {
            if (event.target.checked === true) {
                this.setState({checkEstadoPed: [...this.state.checkEstadoPed, id]});
            } else {
                this.setState({
                    checkEstadoPed: this.state.checkEstadoPed.filter(x => x !== id),
                });
            }
        }
    }


    handleClearFilter() {
        document.querySelectorAll('.dropdown.dropdown-multi').forEach(combo => combo.classList.remove('open'));
        document.querySelectorAll('input[name=comboCheck]').forEach(combo => combo.checked = false);
        this.setState(domain);
        this.setState(cleanPaginacion);
        // this.setState(_extends({},domain,{}));


        if (document.getElementById('checkBoxAll') !== null) {
            document.getElementById('checkBoxAll').checked = false;
        }

    }


    /** ******************************************************************************************** */
    clickDescargarExcel() {
        this.setState({muestraLoad: 'block', muestraDescargas: 'none'});
        var params = this.buildParam();
        this.props.fetchInmatriculacionCorreoDescarga(params).then((result) => {
            if (result.payload.data.estado === 1) {
                const contentType = 'application/vnd.ms-excel';
                const b64Data = result.payload.data.reporte;
                const fileName = 'pedidos.xls';
                saveAs(b64Data, contentType, fileName);
                this.setState({muestraLoad: 'none'});
            } else if (result.payload.data.estado === 0) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: result.payload.data.mensaje
                });
                InmatriculacionCorreo.hideMessage();
            } else if (result.payload.data.estado === -1) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                });
                InmatriculacionCorreo.hideMessage();
            } else {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                });
                InmatriculacionCorreo.hideMessage();
            }
        }).catch(() => {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: '¡Error interno del servidor!'
            });
            InmatriculacionCorreo.hideMessage();
        });
    }


    enviarCorreo(value) {
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });
        var destinatario = [];
        var copias = [];
        value.destinatario && value.destinatario.forEach((item) => {
            destinatario.push(item.text);
        });
        value.copia && value.copia.forEach((item) => {
            copias.push(item.text);
        });

        var dataEnviar = [];
        if (value.item && value.item.fechaTitulo) {
            if (value.item.fechaTitulo && value.item.fechaTitulo.toString().indexOf('/') === -1) {
                var fecha = new Date(value.item.fechaTitulo);
                fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY")
                value.item.fechaTitulo = fecha;
            }
            dataEnviar = [value.item];
        } else {
            if (value.item) {
                dataEnviar = [value.item];
                value.item = null;
            } else {
                const {dataRows} = this.state;
                dataRows.forEach((item) => {
                    var fecha = new Date(item.fechaTitulo);
                    fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY")
                    item.fechaTitulo = fecha;
                });
                dataEnviar = dataRows;
            }
        }

        this.props.postInmatriculacionCorreo({
            'items': dataEnviar,
            'destinatario': destinatario,
            'copias': copias,
            'mensaje': value.mensaje,
            'enviarXml': value.enviarXml,
            'enviarPdf': value.enviarPdf
        }).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                this.closeModal();
                this.setState({registros: [], dataRows: [], selectedID: []});
                this.setState({
                    closeModal: false,
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#1DB89B',
                    mensajeAlert: 'Se Ejecuto Correctamente'
                });
                this.initPaginacion(0, 0);
                document.getElementById('checkBoxAll').checked = false;
                InmatriculacionCorreo.hideMessage();
            } else {
                this.setState({
                    muestraLoad: 'none',
                    selectedID: [],
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor: ${result.payload.data.mensaje}!`
                });
                InmatriculacionCorreo.hideMessage();
            }
            this.setState({selectRow: null});
        }).catch((error) => {
            this.setState({selectRow: null, selectedID: []});
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: '¡Error interno del servidor!'
            });
            InmatriculacionCorreo.hideMessage();
        });
    }

    showError(mensaje) {
        this.setState({
            muestraLoad: 'none',
            iconAlert: 'ion-close-circled',
            colorBackground: '#F56669',
            mensajeAlert: mensaje
        });
        InmatriculacionCorreo.hideMessage();
    }

    openModal = modal => this.setState({modalOpen: modal});
    closeModal = () => {
        this.setState({modalOpen: ''});
    };
    seleccionar = value => this.setState({selectRow: value});

    selectAll() {
        var selectIds = [];
        var data = [];
        var oficinaRegistral = "";
        if (document.getElementById('checkBoxAll').checked) {
            this.state.registros.forEach((item) => {

                if (item.oficinaRegistral === null || item.oficinaRegistral === '') {
                    return;
                }

                if (oficinaRegistral === '') {
                    oficinaRegistral = item.oficinaRegistral;
                }

                if (oficinaRegistral !== item.oficinaRegistral) {
                    return;
                }
                selectIds.push(item.numPedidoVeh);
                data.push(item);
            });
            this.setState({closeModal: true});
        } else {
            this.setState({closeModal: false});
        }
        this.setState({
            selectedID: selectIds,
            dataRows: data,
            countTable: selectIds.length,
            selectOficinaRegistral: oficinaRegistral
        });
    }

    handleOnClickAll = (id, Rows) => {

        if (this.state.selectOficinaRegistral !== '' && (Rows.oficinaRegistral === null || Rows.oficinaRegistral === '')) {
            console.log("Error ... soolo debe seleccionar " + this.state.selectOficinaRegistral);
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: 'Sólo debe selecionar registros con oficina registral '
            });
            return;
        }

        if ('' !== this.state.selectOficinaRegistral && this.state.selectOficinaRegistral && this.state.selectedID.length > 0) {
            if (Rows.oficinaRegistral !== this.state.selectOficinaRegistral && Rows.oficinaRegistral && Rows.oficinaRegistral !== '') {
                console.log("Error ... soolo debe seleccionar " + this.state.selectOficinaRegistral);
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: 'Sólo debe selecionar registros con oficina registral ' + this.state.selectOficinaRegistral
                });
                InmatriculacionCorreo.hideMessage();
                return;
            }
        }

        if (this.state.selectedID.indexOf(id) >= 0) {
            this.state.selectedID.splice(this.state.selectedID.indexOf(id), 1);
            this.state.dataRows.splice(this.state.dataRows.indexOf(Rows), 1);
        } else {
            this.setState({
                selectedID: [...this.state.selectedID, id],
                dataRows: [...this.state.dataRows, Rows],
                closeModal: true,
            });
            if (Rows.oficinaRegistral && Rows.oficinaRegistral !== '') {
                this.setState({
                    selectOficinaRegistral: Rows.oficinaRegistral
                });
            }
        }
        this.setState({
            countTable: this.state.selectedID.length,
        });
    };

    onClickOptinTab(value, cantidadxPag, nroPag) {
        this.setState({muestraLoad: 'block', selectedID: []});
        if (this.state.estado !== value) {
            this.setState({estado: value});
        }
        const validacion = this.validacionGrilla();
        if (validacion.ocurrioError) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: validacion.ocurrioErrorMensaje
            });
            InmatriculacionCorreo.hideMessage();
        } else {
            this.search(PAG_1, CANT_X_PAG);
        }
    }

    handleAllOption() {
        if (this.state.closeModal === false) {
            return (<div/>);
        } else if (this.state.selectedID.length > 0) {

            return (
                <div className='alert alert-actions js-open-flex' id='entregaProgramados-tableActions'>
                    <p><span className='bold'>{this.state.selectedID.length} </span><span className='regular'>Elementos seleccionados</span>
                    </p>
                    <button className='btn btn-blue' onClick={() => {
                        this.openModal('enviar-correo', this);
                        this.setState({selectRow: null});
                    }}>Enviar Correo
                    </button>
                    <p><span className='regular'>Oficina Registral: </span><span
                        className='bold'>{this.state.selectOficinaRegistral} </span></p>

                </div>
            );
        }
    }

    renderTable() {
        return (
            <TablaInmatriculacionCorreo
                selectAll={this.selectAll}
                openModal={this.openModal}
                seleccionar={this.seleccionar}
                handleOnClickAll={this.handleOnClickAll}
                selectedID={this.state.selectedID}
                showModal={this.showModal}
                registros={!this.state.registros ? [] : this.state.registros}
            />);
    }

    render() {
        return (
            <div>

                <div className='pageHead'>
                    <MainRowSection clickDescargarExcel={this.clickDescargarExcel} clickDescargas={this.clickDescargas}
                    />

                    <div className='pageHead-rowContainer'>
                        <div className='pageHead-filters wrapper'>
                            <div className='pageHead-filters-search'>
                                <div className='fSearch'>

                                    <ComboCheck
                                        name='Tipo Operación'
                                        idComponente={COMBO_CHECK_TIPO_CONSULTA}
                                        onClickFiltrar={this.handleClickComboCheckFiltrar}
                                        onClickCheck={this.handleInputChangeComboCheck}
                                        lista={!this.state.cmbTipoConsulta ? [] : this.state.cmbTipoConsulta}
                                        id='id'
                                        nombre='descripcion'
                                        total={this.state.checkTipoConsulta.length}
                                        withButton
                                    />

                                </div>
                            </div>
                            <div className='pageHead-filters-drops'>
                                <ComboCheck
                                    name='Situaciones'
                                    widthClass='col-200'
                                    idComponente={COMBO_CHECK_SITUACIONES}
                                    onClickFiltrar={this.handleClickComboCheckFiltrar}
                                    onClickCheck={this.handleInputChangeComboCheck}
                                    lista={!this.state.situaciones ? [] : this.state.situaciones}
                                    id='id'
                                    nombre='descripcion'
                                    total={this.state.checkSituaciones.length}
                                    withButton
                                />
                                <div className='fSearch'>
                                    <div className='fSearch-filter fSearch-filter-width-180 form-control'><i
                                        className='ion-calendar'/>
                                        <select value={this.state.tipoFecha}
                                                onChange={this.changeSearchOptionFechas}>
                                            {
                                                this.state.cmbFiltroFecha.map(item =>
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.descripcion}
                                                    </option>
                                                )}
                                        </select>
                                    </div>
                                    <DatePicker
                                        selected={this.state.fechaInicio}
                                        className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                                        dateFormat='DD/MM/YYYY'
                                        locale='es'
                                        onChange={this.handleChangeFechaInicio}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.preventDefault();
                                                this.searchAll();
                                            }
                                        }}
                                        id='fechaInicio'
                                        ref={(datepicker) => {
                                            this.datepickerInicio = datepicker;
                                        }}
                                    />
                                    <DatePicker
                                        selected={this.state.fechaFin}
                                        className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                                        dateFormat='DD/MM/YYYY'
                                        locale='es'
                                        onChange={this.handleChangeFechaFin}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.preventDefault();
                                                this.searchAll();
                                            }
                                        }}
                                        id='fechaFin'
                                        ref={(datepicker) => {
                                            this.datepickerFinal = datepicker;
                                        }}
                                    />
                                    <button
                                        className='btn btn-dark fSearch-go checkDeGrillaCerrar'
                                        onClick={this.searchAll}
                                        title='Filtrar'
                                    ><i className='ion-android-arrow-forward'/></button>
                                </div>


                                <ComboCheck
                                    name='Oficina Registral'
                                    idComponente={COMBO_CHECK_OFICINA_REGISTRAL}
                                    onClickFiltrar={this.handleClickComboCheckFiltrar}
                                    onClickCheck={this.handleInputChangeComboCheck}
                                    lista={!this.state.oficinaRegistral ? [] : this.state.oficinaRegistral}
                                    id='id'
                                    nombre='descripcion'
                                    total={this.state.checkOficinaRegistral.length}
                                    withButton
                                />
                                <button
                                    className='btn btn-default pageHead-filters-extra checkDeGrillaCerrar'
                                    data-toggle='modal'
                                    data-target='#moreFilters'
                                    title='Más filtros'
                                    onClick={this.abrirModalMasFiltros}
                                >Más filtros
                                </button>
                                <button
                                    className='btn pageHead-tableConf-clean checkDeGrillaCerrar'
                                    data-toggle='tooltip'
                                    data-placement='top'
                                    title='Limpiar filtros'
                                    data-original-title='Limpiar filtros'
                                    onClick={() => this.handleClearFilter()}
                                >
                                    <i className='ion-funnel'/>
                                </button>
                            </div>

                        </div>

                    </div>
                    <div className='pageHead-rowContainer'>
                        <div className='pageHead-tableConf wrapper'>
                            <div>
                            </div>
                            <div className='pageHead-tableConf-pagCols'>
                                <nav className='pag'>
                                    <p className='pag-label'>
                                        <span>{this.state.nInicio}</span><span> -</span><span> {this.state.nFin}</span><span> de</span><span> {this.state.totalRegistros}</span>
                                    </p>
                                    <div className='pag-arrows'>
                                        <a className='btn btn-default pag-link checkDeGrillaCerrar' title='Anterior'
                                           onClick={this.atras}><i className='ion-chevron-left'/></a>
                                        <a className='btn btn-default pag-link checkDeGrillaCerrar' title='Siguiente'
                                           onClick={this.siguiente}><i className='ion-chevron-right'/></a>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>

                </div>

                <div className='wrapper'>
                    <div className='tab-content'>
                        {this.renderTable()}
                    </div>
                </div>

                <div className='modal extraFilter' role='dialog' data-backdrop='static'
                     style={{zIndex: '2000', display: this.state.muestraLoad}}>
                    <div className='modal-dialog modal-sm' role='document'>
                        <FadeLoader color={'#F8A14A'} loading/>
                    </div>
                </div>

                <div className='alert alert-warning' role='alert' id='alert'
                     style={{display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground}}>
                    <i className={this.state.iconAlert}/>
                    <p>{this.state.mensajeAlert}</p>
                </div>

                {
                    this.handleAllOption()
                }

                {showModal(this.state.modalOpen, this)}

                <div className='modal extraFilter' id='moreFilters' role='dialog' data-backdrop='static'
                     style={{display: this.state.muestraModalMasFiltros}}>
                    <div className='modal-dialog modal-sm modal-pullRight' role='document'>
                        <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal'
                                onClick={this.cerrarModalMasFiltros}>Cerrar ventana
                        </button>
                        <div className='modal-content'>
                            <div className='modal-body'>
                                <h2 className='modal-title'>Más filtros</h2>
                                <div className='form-group'>
                                    <label className='labelInfo'>Estado de Pedido
                                    </label>
                                    <ComboCheck
                                        name='Estado pedido' idComponente={COMBO_CHECK_ESTADOPED}
                                        onClickCheck={this.handleInputChangeComboCheck}
                                        lista={!this.props.estadoPedido ? [] : this.props.estadoPedido}
                                        id='codEstadoPedido'
                                        nombre='desEstadoPedido'
                                        total={this.state.checkEstadoPed.length}
                                    />
                                </div>
                                <div className='form-group'>
                                    <div className='fSearch'>
                                        <div className='fSearch-filter form-control'>
                                            <select value={this.state.tipoFiltro} onChange={this.changeSearchOption}>
                                                <option value='P'>N° Pedido</option>
                                                <option value='C'>N° Chasis</option>
                                                <option value='T'>Titulo</option>
                                            </select>
                                        </div>
                                        <input
                                            type='text'
                                            className='fSearch-search form-control checkDeGrillaEnterCerrar'
                                            value={this.state.filtro}
                                            onChange={this.changeSearchOptionValue}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    this.searchAll();
                                                }
                                            }}
                                        />
                                        <button
                                            className='btn btn-dark fSearch-go checkDeGrillaCerrar'
                                            type='button'
                                            title='Filtrar'
                                            onClick={() => this.searchAll()}
                                        ><i className='ion-android-arrow-forward'/></button>
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <label className='labelInfo'>Nombre del cliente
                                    </label>
                                    <div className='fSearch'>
                                        <input value={this.state.cliente} onChange={this.changeCliente}
                                               id='asesorComercial'
                                               className='form-control'
                                        />
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <label className='labelInfo'>Estado de envío título
                                    </label>
                                    <select className='form-control' onChange={this.changeEstadoEnvio}>
                                        <option value='T'>Todos</option>
                                        <option value='E'>Enviados</option>
                                        <option value='N'>No Enviados</option>
                                    </select>
                                </div>

                                <div className='row modal-actions'>
                                    <div className='col-xs-12 col-sm-6'>
                                        <button className='btn btn-default btn-block' data-dismiss='modal'
                                                onClick={this.cancelarModalMasFiltros}>Cancelar
                                        </button>
                                    </div>
                                    <div className='col-xs-12 col-sm-6'>
                                        <button className='btn btn-primary btn-block' data-dismiss='modal'
                                                onClick={this.searchAll}>Filtrar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        registros: state.registros,
        estadoPedido: state.estadoPedido
    };
}

InmatriculacionCorreo.defaultProps = {
    estadoPedido: [],
    registros: []
};
export default connect(mapStateToProps, {
    loadInmatriculacionCorreo,
    fetchSituacion,
    fetchEstadoPedido,
    fetchInmatriculacionCorreo,
    fetchInmatriculacionCorreoDescarga,
    postInmatriculacionCorreo,
})(InmatriculacionCorreo);



// WEBPACK FOOTER //
// ./src/containers/InmatriculacionCorreo.js